module.exports = __webpack_public_path__ + "static/media/venetian10.b3ddefaa.png";